import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { authService } from '../../services/authService';
import AuthPage from './AuthPage';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await authService.forgotPassword(email);
      if (response?.data?.success) {
        setSuccess(true);
      } else {
        setError(response?.data?.message || 'Failed to send reset email. Please try again.');
      }
    } catch (err) {
      setError(
        err.response?.data?.message ||
          err.response?.data?.errors?.email?.[0] ||
          'Failed to send reset email. Please try again.'
      );
    }

    setLoading(false);
  };

  if (success) {
    return (
      <AuthPage>
        <h1 className="marketing-display-md text-center text-m-ink">Check your email</h1>
        <p className="marketing-body mt-3 text-center text-m-ink-muted">
          We sent a password reset link to{' '}
          <span className="font-medium text-m-ink">{email}</span>.
        </p>
        <p className="mt-4 text-center text-sm text-m-ink-muted">
          Didn’t see it? Check spam, or{' '}
          <button
            type="button"
            onClick={() => {
              setSuccess(false);
              setEmail('');
            }}
            className="font-medium text-m-ink underline underline-offset-2"
          >
            try again
          </button>
          .
        </p>
        <Link to="/login" className="marketing-btn marketing-btn-ink mt-8 w-full">
          Back to sign in
        </Link>
      </AuthPage>
    );
  }

  return (
    <AuthPage>
      <h1 className="marketing-display-md text-center text-m-ink">Forgot password</h1>
      <p className="marketing-body mt-2 text-center text-m-ink-muted">
        We’ll email you a reset link.
      </p>

      <form className="mt-8 space-y-3" onSubmit={handleSubmit}>
        {error && (
          <div className="rounded-2xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-600">
            {error}
          </div>
        )}
        <input
          id="email"
          name="email"
          type="email"
          autoComplete="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Email"
          className="auth-input"
        />
        <button
          type="submit"
          disabled={loading}
          className="marketing-btn marketing-btn-ink w-full"
        >
          {loading ? 'Sending…' : 'Send reset link'}
        </button>
        <p className="text-center text-sm text-m-ink-muted">
          Remember your password?{' '}
          <Link to="/login" className="font-medium text-m-ink underline underline-offset-2">
            Sign in
          </Link>
        </p>
      </form>
    </AuthPage>
  );
};

export default ForgotPassword;
